import * as ambassadorWixMultilingualSettingsV2LocaleSettings from './multilingual-settings-v2-locale-settings-locale-settings.http.js';
import * as ambassadorWixMultilingualSettingsV2LocaleSettingsTypes from './multilingual-settings-v2-locale-settings-locale-settings.types.js';
import * as ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes from './multilingual-settings-v2-locale-settings-locale-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getLocaleSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.GetLocaleSettingsRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.GetLocaleSettingsRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.GetLocaleSettingsResponse,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.GetLocaleSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualSettingsV2LocaleSettings.getLocaleSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLocaleSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.UpdateLocaleSettingsRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.UpdateLocaleSettingsRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.UpdateLocaleSettingsResponse,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.UpdateLocaleSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualSettingsV2LocaleSettings.updateLocaleSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setMultilingualMode(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.SetMultilingualModeRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.SetMultilingualModeRequest,
  ambassadorWixMultilingualSettingsV2LocaleSettingsUniversalTypes.SetMultilingualModeResponse,
  ambassadorWixMultilingualSettingsV2LocaleSettingsTypes.SetMultilingualModeResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMultilingualSettingsV2LocaleSettings.setMultilingualMode(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/settings/mode',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LocaleSettings as LocaleSettingsOriginal,
  UrlStructure as UrlStructureOriginal,
  UrlStructureWithLiterals as UrlStructureWithLiteralsOriginal,
  Locale as LocaleOriginal,
  LocaleVisibility as LocaleVisibilityOriginal,
  LocaleVisibilityWithLiterals as LocaleVisibilityWithLiteralsOriginal,
  UrlStructureOverride as UrlStructureOverrideOriginal,
  MultilingualModeUpdated as MultilingualModeUpdatedOriginal,
  GetLocaleSettingsRequest as GetLocaleSettingsRequestOriginal,
  GetLocaleSettingsResponse as GetLocaleSettingsResponseOriginal,
  UpdateLocaleSettingsRequest as UpdateLocaleSettingsRequestOriginal,
  UpdateLocaleSettingsResponse as UpdateLocaleSettingsResponseOriginal,
  SetMultilingualModeRequest as SetMultilingualModeRequestOriginal,
  SetMultilingualModeResponse as SetMultilingualModeResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  QueryLocaleSettingsRequest as QueryLocaleSettingsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLocaleSettingsResponse as QueryLocaleSettingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SetMultilingualModeApplicationErrors as SetMultilingualModeApplicationErrorsOriginal,
} from './multilingual-settings-v2-locale-settings-locale-settings.types.js';
